exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cw-text[data-v-7b9ec35e] {\n  background: -webkit-linear-gradient(\n    45deg,\n    var(--cw-700),\n    var(--cw-alt),\n    var(--cw-alt)\n  );\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  font-size: 60px;\n}\n", ""]);

// exports
